import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import EmptyDataMessage from './EmptyDataMessage.component';
import Loading from '../../common/Loading.component';
import { DetailConf } from '../../../module/yachtDashboard/conf/handover/Detail.conf';
import { DashboardDetail } from '../../detail/DashboardDetail';
import { fetchAPI } from '../../../api/request';
import dayjs from 'dayjs';

const HandoverTabContent = ({ yachtID, filters }) => {
    const { jwt } = useSelector((state) => state.login);
    const { fields, formatValue } = DetailConf;
    const colorTab = '#ffe0b2';

    const [loading, setLoading] = useState(false);
    const [handovers, setHandovers] = useState([]);

    const fetchHandovers = useCallback(() => {
        if (!yachtID) return;

        setLoading(true);

        const { start_date, end_date, id_department } = filters || {};
        const departmentId = id_department?.id;

        const startDateObj = start_date ? dayjs(start_date) : null;
        const endDateObj = end_date ? dayjs(end_date) : null;

        let path =
            `/tickets?populate[id_yacht][fields][0]=yacht_name` +
            `&populate[notes][populate][id_user][populate][id_users_permissions_user][fields][0]=name` +
            `&populate[notes][populate][id_user][populate][id_users_permissions_user][fields][1]=surname` +
            `&populate[id_department][fields][0]=name_department` +
            `&populate[id_team]=*` +
            `&populate[created_by_user_id][populate][id_users_permissions_user][fields][0]=name` +
            `&populate[created_by_user_id][populate][id_users_permissions_user][fields][1]=surname` +
            `&populate[assignee_user_id][populate][id_users_permissions_user][fields][0]=name` +
            `&populate[assignee_user_id][populate][id_users_permissions_user][fields][1]=surname` +
            `&populate[closed_by_user_id][populate][id_users_permissions_user][fields][0]=name` +
            `&populate[closed_by_user_id][populate][id_users_permissions_user][fields][1]=surname` +
            `&filters[id_yacht][id][$eq]=${yachtID}`;

        if (departmentId) {
            path += `&filters[id_department][id][$eq]=${departmentId}`;
        }

        if (startDateObj?.isValid()) {
            path += `&filters[createdAt][$gte]=${startDateObj.startOf('day').toISOString()}`;
        }

        if (endDateObj?.isValid()) {
            path += `&filters[createdAt][$lte]=${endDateObj.endOf('day').toISOString()}`;
        }

        fetchAPI(
            {
                path,
                method: 'GET',
                auth: true,
            },
            {},
            '',
            {},
            jwt
        )
            .then((resp) => {
                const mappedHandovers = (resp?.data || []).map((item) => ({
                    id: item.id,
                    attributes: {
                        type: item.attributes.type || '-',
                        yacht_name: item.attributes.id_yacht?.data?.attributes?.yacht_name || '-',
                        priority: item.attributes.priority || '-',
                        status: item.attributes.status || '-',
                        handover: { title: item.attributes.title || '', description: item.attributes.description || '' },
                        notes:
                            item.attributes.notes?.map((note) => {
                                const user = note?.id_user?.data?.attributes?.id_users_permissions_user?.data?.attributes;

                                return {
                                    comment: note.comment,
                                    created_at_note: note.created_at_note,
                                    id_user: note?.id_user?.data?.id || null,
                                    user_name: user ? `${user.name} ${user.surname}` : '-',
                                };
                            }) || [],
                        department:
                            item.attributes.id_department?.data?.attributes?.name_department ||
                            '-',
                        team: item.attributes.id_team?.data?.attributes?.name || '-',
                        created_by_user:
                            `${item.attributes.created_by_user_id?.data?.attributes
                                ?.id_users_permissions_user?.data?.attributes?.name || ''
                                } ${item.attributes.created_by_user_id?.data?.attributes
                                    ?.id_users_permissions_user?.data?.attributes?.surname || ''
                                }`.trim() || '-',
                        assignee_user:
                            `${item.attributes.assignee_user_id?.data?.attributes
                                ?.id_users_permissions_user?.data?.attributes?.name || ''
                                } ${item.attributes.assignee_user_id?.data?.attributes
                                    ?.id_users_permissions_user?.data?.attributes?.surname || ''
                                }`.trim() || '-',
                        closed_by_user:
                            `${item.attributes.closed_by_user_id?.data?.attributes
                                ?.id_users_permissions_user?.data?.attributes?.name || ''
                                } ${item.attributes.closed_by_user_id?.data?.attributes
                                    ?.id_users_permissions_user?.data?.attributes?.surname || ''
                                }`.trim() || '-',
                        createdAt: item.attributes.createdAt,
                        updatedAt: item.attributes.updatedAt,
                    },
                }));

                setHandovers(mappedHandovers);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching handovers:', error);
                setLoading(false);
            });
    }, [jwt, yachtID, filters]);

    useEffect(() => {
        fetchHandovers();
    }, [fetchHandovers]);

    if (loading) return <Loading />;

    return (
        <Box sx={{ minHeight: '55vh' }}>
            {!_.isEmpty(handovers) ? (
                handovers.map((handover) => (
                    <Link
                        to={`/handover/${handover?.id}`}
                        key={handover?.id}
                        style={{ textDecoration: 'none' }}
                    >
                        <DashboardDetail
                            fields={fields}
                            data={handover}
                            render={formatValue}
                            colorTab={colorTab}
                        />
                    </Link>
                ))
            ) : (
                <EmptyDataMessage message='No handovers found' />
            )}
        </Box>
    );
};

export default HandoverTabContent;